/* Sauer's Bakehouse — Flip-Kit bundle builder controller.
 * Uses document-level event delegation + a MutationObserver so it keeps working
 * after the product is swapped in via AJAX (sibling / flip-kit switch), where
 * inline <script> tags injected through innerHTML never re-run.
 * Also supports picking the SAME flavour more than once (quantity per flavour). */
(function () {
  if (window.__srFlipBuilder) return;
  window.__srFlipBuilder = true;

  function state(root) {
    if (!root._sr) {
      root._sr = {
        pick: parseInt(root.dataset.pick, 10) || 4,
        each: parseInt(root.dataset.each, 10) || 1,
        total: parseInt(root.dataset.total, 10) || 4,
        picked: []
      };
    }
    return root._sr;
  }

  // Flavour cards carry the identifiers the cart needs. Looked up by display
  // name because that is what the picked[] array stores.
  function metaFor(root, name) {
    if (!name) return { id: '', sku: '' };
    var cards = root.querySelectorAll('.sr-fcard');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].dataset.srFlavour === name) {
        return { id: cards[i].dataset.srVariant || '', sku: cards[i].dataset.srSku || '' };
      }
    }
    return { id: '', sku: '' };
  }

  function fillSlot(root, selector, value) {
    [].slice.call(root.querySelectorAll(selector)).forEach(function (inp) { inp.value = value; });
  }

  function atcButtons(root) {
    var ids = [root.dataset.form, root.dataset.sticky].filter(Boolean);
    var sel = ids.map(function (id) { return '#' + id + ' [name="add"]'; }).join(',');
    return sel ? [].slice.call(document.querySelectorAll(sel)) : [];
  }

  // The float bar is position:fixed, so the page has to reserve its height or the
  // last section on the page can never be scrolled clear of it. Publishing the
  // measured height beats hardcoding one in CSS: above 767px the bar is
  // display:none and measures 0, and a ResizeObserver re-measures on rotate and on
  // breakpoint crossings without us owning a resize listener. offsetHeight already
  // includes the safe-area padding, so the strip matches the bar exactly.
  function publishFloatHeight(bar) {
    document.documentElement.style.setProperty('--sr-float-h', bar.offsetHeight + 'px');
  }

  function watchFloatHeight(bar) {
    if (bar._srFloatWatched) return;
    bar._srFloatWatched = true;
    if (window.ResizeObserver) {
      new ResizeObserver(function () { publishFloatHeight(bar); }).observe(bar);
    } else {
      window.addEventListener('resize', function () { publishFloatHeight(bar); });
    }
    publishFloatHeight(bar);
  }

  function render(root) {
    var st = state(root);
    var cards = [].slice.call(root.querySelectorAll('.sr-fcard'));
    var atMax = st.picked.length >= st.pick;
    cards.forEach(function (c) {
      var name = c.dataset.srFlavour;
      var qty = st.picked.filter(function (n) { return n === name; }).length;
      var on = qty > 0;
      c.classList.toggle('on', on);
      // Only non-selected cards lock when the box is full; selected cards keep
      // their − control active so the customer can free up a slot.
      c.classList.toggle('disabled', atMax && !on);
      var ord = c.querySelector('.sr-fcard__order');
      if (ord) ord.textContent = qty > 1 ? ('×' + qty) : (qty === 1 ? '1' : '');
      var txt = c.querySelector('.sr-fcard__txt');
      if (txt) txt.textContent = on ? 'Added' : 'Add';
      var plus = c.querySelector('.sr-fcard__plus');
      if (plus) plus.disabled = atMax || c.classList.contains('is-oos');
    });

    [].slice.call(root.querySelectorAll('[data-sr-count]')).forEach(function (el) {
      el.textContent = st.picked.length;
    });

    for (var s = 1; s <= st.pick; s++) {
      var val = st.picked[s - 1] || '';
      var meta = metaFor(root, val);
      fillSlot(root, '[data-sr-slot="' + s + '"]', val);
      fillSlot(root, '[data-sr-slot-id="' + s + '"]', meta.id);
      fillSlot(root, '[data-sr-slot-sku="' + s + '"]', meta.sku);
    }

    var slipEl = root.querySelector('[data-sr-slip]');
    if (slipEl) {
      var bags = [];
      st.picked.forEach(function (n) { for (var k = 0; k < st.each; k++) bags.push(n); });
      var rows = '';
      for (var i = 0; i < st.total; i++) {
        if (i < bags.length) {
          rows += '<div class="sr-slip__row"><span class="q">1&times;</span><span class="n">' + bags[i] + '</span><span class="d"></span><span class="w">&#10003;</span></div>';
        } else {
          rows += '<div class="sr-slip__row is-empty"><span class="q">&mdash;</span><span class="n">Empty slot</span><span class="d"></span><span class="w">&mdash;</span></div>';
        }
      }
      slipEl.innerHTML = rows;
    }

    var done = st.picked.length === st.pick;
    var left = st.pick - st.picked.length;
    // Update every CTA (the slip button AND the mobile floating bar both carry [data-sr-cta]).
    [].slice.call(root.querySelectorAll('[data-sr-cta]')).forEach(function (cta) {
      cta.disabled = !done;
      cta.classList.toggle('is-ready', done);
      cta.textContent = done ? 'Add bundle to cart →' : ('Pick ' + left + ' more flavour' + (left === 1 ? '' : 's'));
    });
    // Reveal the mobile floating add-to-cart bar only once the box is full.
    var floatBar = root.querySelector('[data-sr-float]');
    if (floatBar) {
      floatBar.classList.toggle('is-visible', done);
      floatBar.setAttribute('aria-hidden', done ? 'false' : 'true');
      watchFloatHeight(floatBar);
    }
    atcButtons(root).forEach(function (b) {
      b.disabled = !done;
      b.classList.toggle('sr-atc-locked', !done);
    });

    if (root.dataset.key) {
      try { localStorage.setItem(root.dataset.key, JSON.stringify(st.picked)); } catch (e) {}
    }
  }

  function initBuilder(root) {
    if (!root || root.dataset.srReady) return;
    root.dataset.srReady = '1';
    var st = state(root);
    if (root.dataset.key) {
      try {
        var saved = JSON.parse(localStorage.getItem(root.dataset.key) || '[]');
        if (Array.isArray(saved)) {
          // Drop anything that is no longer a card, or has since sold out —
          // a restored pick must never be one the customer couldn't make now.
          st.picked = saved.filter(function (n) {
            var el = root.querySelector('.sr-fcard[data-sr-flavour="' + (window.CSS && CSS.escape ? CSS.escape(n) : n) + '"]');
            return el && !el.classList.contains('is-oos');
          }).slice(0, st.pick);
        }
      } catch (e) {}
    }
    render(root);
  }

  function initAll(scope) {
    [].slice.call((scope || document).querySelectorAll('.sr-builder')).forEach(initBuilder);
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('.sr-fcard__plus');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      var proot = plus.closest('.sr-builder');
      var pcard = plus.closest('.sr-fcard');
      if (!proot || !pcard) return;
      if (pcard.classList.contains('is-oos')) return;
      var pst = state(proot);
      if (pst.picked.length < pst.pick) { pst.picked.push(pcard.dataset.srFlavour); render(proot); }
      return;
    }
    var card = e.target.closest('.sr-fcard');
    if (card) {
      var croot = card.closest('.sr-builder');
      if (!croot) return;
      if (card.classList.contains('disabled') || card.classList.contains('is-oos')) return;
      var cst = state(croot);
      var nm = card.dataset.srFlavour;
      var have = cst.picked.lastIndexOf(nm);
      if (have > -1) {
        cst.picked.splice(have, 1); // tap a selected flavour to remove one
      } else if (cst.picked.length < cst.pick) {
        cst.picked.push(nm);
      }
      render(croot);
      return;
    }
    var cta = e.target.closest('[data-sr-cta]');
    if (cta) {
      var troot = cta.closest('.sr-builder');
      if (!troot) return;
      var tst = state(troot);
      if (tst.picked.length !== tst.pick) return;
      var btn = atcButtons(troot)[0];
      if (btn) { btn.disabled = false; btn.classList.remove('sr-atc-locked'); btn.click(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var card = e.target.closest ? e.target.closest('.sr-fcard') : null;
    if (card && e.target === card) { e.preventDefault(); card.click(); }
  });

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      [].slice.call(m.addedNodes || []).forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('.sr-builder')) initBuilder(n);
        if (n.querySelectorAll) initAll(n);
      });
    });
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); });
})();
